import { render, staticRenderFns } from "./AllegatiMov.vue?vue&type=template&id=1757628e"
import script from "./AllegatiMov.vue?vue&type=script&lang=js"
export * from "./AllegatiMov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports